import { ComponentMessageItem } from '../UNSAFE_ComponentMessage';

import { createFileList } from './filePickerUtils';
import { RejectDetail, CommitDetail } from './FilePicker';

/**
 * Calls the onReject callback when invalid files are selected.
 * For invalid dragged files, this function will return a promise resolver that
 * should be called when the invalid files are no longer dragged over the filepicker.
 */
export const fireRejectAction = (
  messages: ComponentMessageItem[],
  isDrag: boolean,
  onReject?: (detail: RejectDetail) => void
) => {
  let resolver;
  const dragPromise = isDrag
    ? new Promise<void>((resolve) => {
        resolver = resolve;
      })
    : null;

  onReject?.({
    messages,
    until: dragPromise
  });
  return resolver;
};

/**
 * Calls the onCommit callback when all files are valid.
 */
export const handleFilesAdded = (files: FileList, onCommit?: (detail: CommitDetail) => void) => {
  // Bug 28503874 - filepicker: filelist cleared after the handler returns
  // Note: the parameter "files" is a direct reference to the embedded Input element's property
  // which could be reset or changed.
  // we need to return a copy of FileList just in case apps hold on to a reference to FileList
  const list = createFileList(files);
  onCommit?.({
    files: list
  });
};
